import { Card } from "@/components/card"
import { ClFarmStore } from "@/domains/cl-farm/cl-farm-store"
import { cn } from "@/domains/library"
import {
  BribesAddressInfo,
  ClassicPoolAddressInfo,
  FeesAddressInfo,
  TokenAddressInfo,
} from "@/domains/minimal-pool/components/minimal-pool-addresses-card"

export const ClFarmAddresses = ({
  clFarm,
  className,
}: {
  clFarm: ClFarmStore | null | undefined
  className?: string
}) => {
  return (
    <Card.Container className={cn("p-4 lg:p-4", className)}>
      <TokenAddressInfo
        address={clFarm?.token0?.address.toViemAddress()}
        label="Asset Token0"
        symbol={clFarm?.token0?.symbol}
      />
      <TokenAddressInfo
        address={clFarm?.token1?.address.toViemAddress()}
        label="Base Token1"
        symbol={clFarm?.token1?.symbol}
      />
      <ClassicPoolAddressInfo address={clFarm?.address.toViemAddress()} label="Pool" />
      <BribesAddressInfo address={clFarm?.bribeAddress?.toViemAddress()} label="Bribe" />
      <FeesAddressInfo address={clFarm?.feeAddress?.toViemAddress()} label="Fees" />
    </Card.Container>
  )
}
